import { FC, useEffect, useRef } from "react";
import { useTranslation } from "@cronika/locales";
import { useBetUpdates } from "@/features/common/socket";
import { handleBetNotification, preloadSounds } from "../services/betNotificationService";
import { BetOutcome } from "@cronika/proto/common/trading_pb";
import { AccountType } from "@cronika/proto/common/billing_pb";

type BetNotificationsProps = {
  onDemoWin?: () => void;
};

export const BetNotifications: FC<BetNotificationsProps> = ({ onDemoWin }) => {
  const { t } = useTranslation("trading");
  const { lastBet } = useBetUpdates();
  const onDemoWinRef = useRef(onDemoWin);
  const lastProcessedDemoWinIdRef = useRef<string | null>(null);

  useEffect(() => {
    preloadSounds();
  }, []);

  useEffect(() => {
    onDemoWinRef.current = onDemoWin;
  });

  useEffect(() => {
    if (!lastBet) return;
    handleBetNotification(lastBet, t);

    if (
      lastBet.type === "bet.settled" &&
      lastBet.data.outcome === BetOutcome.WON &&
      lastBet.data.accountType === AccountType.DEMO &&
      lastBet.data.id !== lastProcessedDemoWinIdRef.current
    ) {
      lastProcessedDemoWinIdRef.current = lastBet.data.id;
      onDemoWinRef.current?.();
    }
  }, [lastBet, t]);

  return null;
};
